import React from "react";
import { LoadingButton } from "@mui/lab";
import { Box, Modal, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";

const NoSpotReservationModal = ({ isOpen, onCancel, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Modal
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      open={isOpen}
    >
      <Box
        sx={{
          background: "white",
          width: "480px",
          maxWidth: "95vw",
          p: 2,
          borderRadius: 1,
        }}
      >
        <Stack>
          <Typography color={"#323130"} variant="h5">
            {t("components.noSpotReservationModal.text01")}
          </Typography>

          <Typography sx={{ mt: 1 }} color={"#605E5C"} variant="fontSize16">
            {t("components.noSpotReservationModal.text02")}
          </Typography>

          <Box mt={2} display={"flex"} justifyContent={"space-around"}>
            <LoadingButton
              size="small"
              sx={{ height: "40px", width: "100px" }}
              variant="outlined"
              type="submit"
              style={{
                backgroundColor: "#fff",
                borderColor: "#8A8886",
                color: "#605E5C",
                width: "100px",
              }}
              onClick={onCancel}
            >
              {t("commonLabels.text22")}
            </LoadingButton>

            <LoadingButton
              size="small"
              sx={{ width: "100px", height: "40px" }}
              loading={false}
              color="primary"
              onClick={() => null}
              variant="contained"
            >
              {t("commonLabels.text21")}
            </LoadingButton>
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
};

NoSpotReservationModal.propTypes = {};

export default React.memo(NoSpotReservationModal);
